import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import NewsLanding from "../views/NewsLanding";
import NewsDetails from "../views/NewsDetails";

export default function News() {
  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  useEffect(() => {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      setView(<NewsLanding />);
    } else if (
      appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      setView(<NewsDetails newsSlug={appContext.navSubItem} />);
    } else {
      setView(null);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  return view;
}
